import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../Base/Components/BaseModal/BaseModal';
import RequirementNote from './RequirementNote';

interface Props extends BaseModalProps {
	requirementId: string;
	note?: string;
	onEdit: (note: string) => void;
}

const RequirementNoteModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.shared.note'>
			<RequirementNote
				requirementId={props.requirementId}
				note={props.note}
				onEdit={props.onEdit}
			/>
		</BaseModal>
	);
};

export default RequirementNoteModal;
